import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchCropYearDropdownData, fetchCropYearFieldName, fetchCropYearDropdown, postCropYearData, fetchCropYearGrid, updateCropYearGridView, approveCropYearGridView, deleteCropYearGridView, fetchAllCropYearData, bulkTransferCropYearGrid } from "../services/cropyear.api";

type CalYear = {
    year: number;
};

interface CropYearDropdownState {
    cropYear: CalYear[];
    farmName: [];
    fieldName: [];
    cropName: [];
    totalFarmAcres: [];
    gridData: [],
    responsebool: boolean,
    deleteresonse: boolean,
    loading: boolean;
    error: string | null;
    approveresponse: boolean;
    modifyresponse: boolean;
    selectedApproveRecord: any;
    recordData: any;
    currentaddedData: any;
    cropYearList: any[];
}

const initialState: CropYearDropdownState = {
    cropYear: [],
    farmName: [],
    fieldName: [],
    cropName: [],
    totalFarmAcres: [],
    gridData: [],
    loading: false,
    error: null,
    responsebool: false,
    deleteresonse: false,
    approveresponse: false,
    modifyresponse: false,
    selectedApproveRecord: null,
    recordData: [],
    currentaddedData: [],
    cropYearList: []
};

export const fetchCropYearsDropdown = createAsyncThunk(
    "cropyeardropdown/fetch",
    async (dropdownType: string) => {
        const response = await fetchCropYearDropdownData(dropdownType);
        return response.data;
    }
);

export const fetchCropYearFieldDropdown = createAsyncThunk(
    "cropyearfielddropdown/fetch",
    async ({ value, cropYear }: { value: string, cropYear: number }) => {
        const response = await fetchCropYearFieldName(value, cropYear);
        return response.data;
    }
);

export const fetchCropYearsDropdownData = createAsyncThunk(
    "cropyearsdropdown/fetch",
    async ({ type, value }: { type: string, value: string }) => {
        const response = await fetchCropYearDropdown(type, value);
        return response.data;
    }
);

export const postCropYearDropdown = createAsyncThunk(
    "cropYeardropdown/post",
    async (value: any) => {
        const response = await postCropYearData(value);
        return response.data;
    }
);

export const postCropYearGrid = createAsyncThunk(
    "cropYeargrid/fetch",
    async (value: any) => {
        const response = await fetchCropYearGrid(value);
        return response.data;
    }
);

export const updateCropYearGrid = createAsyncThunk(
    "cropYeargrid/update",
    async (value: any) => {
        const response = await updateCropYearGridView(value);
        return response.data;
    }
);

export const approveCropYearGrid = createAsyncThunk(
    "cropYeargrid/updated",
    async (value: any) => {
        const response = await approveCropYearGridView(value);
        return response.data;
    }
);

export const deleteCropYearGrid = createAsyncThunk(
    "cropYeargrid/delete",
    async (value: any) => {
        const response = await deleteCropYearGridView(value);
        return response.data;
    }
);

export const fetchAllCropYear = createAsyncThunk(
    "allcropyear/fetch",
    async (year: number) => {
        const response = await fetchAllCropYearData(year);
        return response.data;
    }
);
export const bulkTransferCropYearData = createAsyncThunk(
    "bulkservicegrid/update",
    async (value: any) => {
        const response = await bulkTransferCropYearGrid(value);
        return response.data;
    }
);
const cropyeardropdownSlice = createSlice({
    name: "cropyeardropdown",
    initialState,
    reducers: {
        setSelectedApproveRecord: (state, action) => {
            state.selectedApproveRecord = action.payload;
        },
        resetapproveresponse: (state) => {
            state.approveresponse = false;
        },
        resetmodifyresponse: (state) => {
            state.modifyresponse = false;
        },
        setCurrentAddedData: (state, action) => {
            state.currentaddedData = action.payload;
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCropYearsDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCropYearsDropdown.fulfilled, (state, action) => {
                state.loading = false;
                if (action.meta.arg === "cropYear") {
                    state.cropYear = action.payload;
                } else if (action.meta.arg === "farmName") {
                    state.farmName = action.payload;
                }
            })
            .addCase(fetchCropYearsDropdown.rejected, (state) => {
                state.loading = false;
                state.error = "Failed to fetch dropdown data.";
            })
            .addCase(fetchCropYearFieldDropdown.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCropYearFieldDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.fieldName = action.payload;
            })
            .addCase(fetchCropYearFieldDropdown.rejected, (state) => {
                state.loading = false;
                state.error = "Failed to fetch dropdown data.";
            })
            .addCase(fetchCropYearsDropdownData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchCropYearsDropdownData.fulfilled, (state, action) => {
                state.loading = false;
                if (action.meta.arg.type === "cropName") {
                    state.cropName = action.payload;
                } else if (action.meta.arg.type === "totalFarmAcres") {
                    state.totalFarmAcres = action.payload;
                }
            })
            .addCase(fetchCropYearsDropdownData.rejected, (state) => {
                state.loading = false;
                state.error = "Failed to fetch dropdown data.";
            })
            .addCase(postCropYearGrid.fulfilled, (state, action) => {
                state.loading = false;
                state.gridData = action.payload;
            })
            .addCase(postCropYearDropdown.fulfilled, (state, action) => {
                state.loading = false;
                state.responsebool = !state.responsebool;
                state.recordData = action.payload;
            })
            .addCase(deleteCropYearGrid.fulfilled, (state) => {
                state.loading = false;
                state.error = null;
            })
            .addCase(deleteCropYearGrid.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || 'An error occurred';
            })
            .addCase(approveCropYearGrid.fulfilled, (state) => {
                state.loading = false;
                state.approveresponse = !state.approveresponse;
            })
            .addCase(updateCropYearGrid.fulfilled, (state) => {
                state.loading = false;
                state.modifyresponse = !state.modifyresponse;
            })
            .addCase(fetchAllCropYear.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAllCropYear.fulfilled, (state, action) => {
                state.loading = false;
                state.cropYearList = action.payload;
            })
            .addCase(fetchAllCropYear.rejected, (state) => {
                state.loading = false;
                state.error = "Failed to fetch data.";
            });
    },
});

export const { resetmodifyresponse, resetapproveresponse, setSelectedApproveRecord, setCurrentAddedData } = cropyeardropdownSlice.actions;
export default cropyeardropdownSlice.reducer;

